import { faMinus } from "@jewlr/pro-light-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-light-svg-icons/faPlus"
import { Expand } from "@jewlr/storybook/animate"
import { Box, Button, FontAwesomeIcon, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import { SectionTitle, FooterLink } from "./components"

const AccordionHeading = styled(Button).attrs((props) => ({
  alignItems: "center",
  justifyContent: "space-between",
  variant: "text",
  width: "100%",
  ...props,
}))`
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 20px;

  ${(props) =>
    !props.showMenu &&
    `
    border-bottom: 1px solid ${props.theme.colors.white};
  `}
`

const FooterContentMobile = ({ data }) => {
  const [showMenu, setShowmenu] = useState(false)

  return (
    <MediaBox lessThan="tablet">
      <Box as="h2" m="0" p="0">
        <AccordionHeading
          aria-controls={`footer-mobile-content-${data.title}`}
          aria-expanded={showMenu}
          id={`footer-mobile-heading-${data.title}`}
          onClick={() => setShowmenu(!showMenu)}
          showMenu={showMenu}
        >
          <SectionTitle>{data.title}</SectionTitle>
          <FontAwesomeIcon
            color="white"
            fontSize="16px"
            icon={showMenu ? faMinus : faPlus}
          />
        </AccordionHeading>
      </Box>
      <Expand
        aria-labelledby={`footer-mobile-heading-${data.title}`}
        id={`footer-mobile-content-${data.title}`}
        mb={3}
        mt={2}
        px={2}
        role="menu"
        show={showMenu}
      >
        {data.links
          .filter((link) => typeof link.show === "undefined" || link.show)
          .map((link, i) => (
            <FooterLink
              data-cy={`footer-link-${link.name}`}
              data-lc="footer"
              key={`footerlinke_${i}`}
              my="6px"
              role="menuitem"
              to={link.url}
              {...link.options}
            >
              {link.name}
            </FooterLink>
          ))}
      </Expand>
    </MediaBox>
  )
}

FooterContentMobile.propTypes = {
  data: PropTypes.object,
}

export default FooterContentMobile
